import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import PropTypes from "prop-types";
import { options } from "toastr";

export default function ProvinceCustomerPieChart(props) {
  const {
    dataCharts: { laedGroupByProvince = [] },
  } = props;

  const [series, setSeries] = useState([44, 55, 41, 17, 15]);
  const [options, setOptions] = useState({
    labels: ["Series 1", "Series 2", "Series 3", "Series 4", "Series 5"],
    colors: ["#34c38f", "#556ee6", "#f46a6a", "#50a5f1", "#f1b44c"],
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "center",
      verticalAlign: "middle",
      floating: false,
      fontSize: "14px",
      offsetX: 0,
      offsetY: -10,
    },
    responsive: [
      {
        breakpoint: 600,
        options: {
          chart: {
            height: 240,
          },
          legend: {
            show: false,
          },
        },
      },
    ],
  });

  useEffect(() => {
    const dataCustomerProvince = laedGroupByProvince.map(item => {
      return item.count;
    });
    const labelCustomerProvince = laedGroupByProvince.map(item => {
      if (item.objectId === null) item.objectId = "Không có thông tin";
      return item.objectId;
    });

    setSeries(dataCustomerProvince);
    setOptions({
      ...options,
      labels: labelCustomerProvince,
    });
  }, [props]);

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="pie"
      height="350"
      className="apex-charts"
    />
  );
}

ProvinceCustomerPieChart.propTypes = {
  dataCharts: PropTypes.object,
};
